import { default as Link } from './Link';

export default Link;
